import React, { FC, useMemo } from 'react';
import { TableFooter } from './ReportsSetupTable.styles';
import { IPagingInfo, IReportsSetupItem } from '../../../services/surveys';
import GoToPage from '../../GoToPage/GoToPage';
import Pagination from '../../Pagination/Pagination';
import RowsPerPage from '../../RowsPerPage/RowsPerPage';
import ReportsSetupTableTile from '../ReportsSetupTableTile/ReportsSetupTableTile';

interface IReportsSetupTable {
  reportsGroup: IReportsSetupItem[];
  pagingInfo: IPagingInfo;
  applyFilters: (filters: Record<string, string | null | undefined>) => void;
  updateFullTable: () => Promise<void>;
  deleteItem: (item: IReportsSetupItem) => void;
  editItem: (item: IReportsSetupItem) => void;
  isEffectSurvey: boolean;
}

const ReportsSetupTable: FC<IReportsSetupTable> = ({
  reportsGroup,
  deleteItem,
  editItem,
  updateFullTable,
  pagingInfo: { itemsPerPage, totalPageCount, pageNo },
  applyFilters,
  isEffectSurvey,
}) => {
  const renderReportsGroup = useMemo(() => {
    return reportsGroup.map(group => (
      <ReportsSetupTableTile
        key={group.id}
        name={group.name}
        type={group.type}
        id={group.id}
        memberCount={group.memberCount}
        searchMembers={group.members?.items}
        deleteItem={deleteItem}
        editItem={editItem}
        updateFullTable={updateFullTable}
        isEffectSurvey={isEffectSurvey}
      />
    ));
  }, [reportsGroup, deleteItem, editItem, updateFullTable]);

  return (
    <>
      {renderReportsGroup}
      <TableFooter id="TableFooter">
        <RowsPerPage
          itemsPerPage={Number(itemsPerPage)}
          pagesCount={Number(totalPageCount)}
          menu={['7', '15', '25', '50', '75', '100']}
        />
        <Pagination
          activePage={Number(pageNo)}
          totalPageCount={Number(totalPageCount)}
          applyFilters={(pageNo: number) => applyFilters({ pageNo: String(pageNo) })}
        />
        <GoToPage applyFilters={applyFilters} pageLimit={totalPageCount} />
      </TableFooter>
    </>
  );
};

export default ReportsSetupTable;
